<template>
    <div v-if="source">
        <a v-if="isLink(source)" :href="source" target="_blank">
            <span v-if="includeSource">{{ $t("source") }}: </span>{{ $t("registr") }} <b-icon icon="box-arrow-up-right" font-scale="0.6" style="margin-bottom: 5px;"></b-icon>
        </a>
        <span class="light_italic" v-if="!isLink(source)">
            <span v-if="includeSource">{{ $t("source") }}: </span>{{ source }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        source: { default: null, type: String },
        includeSource: { default: true, type: Boolean }
    },
    methods: {
        isLink: function(value) {
            return value.toLowerCase().startsWith("http");
        }
    }
}
</script>

<style lang="scss">
</style>